<template>
  <div class="page">
    <!-- 顶部LOGO及导航链接 -->
    <common-header></common-header>

    <div class="main-body" style="background-color: #f8f8f8;">
      <div class="container" style="padding-top: 10px;">
        <!-- 导航 -->
        <div style="margin-bottom: 10px; font-size: 14px; line-height: 1.8;">
          <router-link to="/news" style="text-decoration: none; color: #25afee;">新闻列表</router-link>
          <span style="padding-left: 5px; padding-right: 5px;">/</span>
          <span style="color: #999999;">新闻详情</span>
        </div>
        <!-- 文章列表 -->
        <div v-if="news" class="news-wrapper">
          <div class="title">{{news.title}}</div>
          <div class="publish-time">{{$formator.formatDate(news.publishTime)}}</div>
          <div class="content" v-html="news.content">
          </div>
        </div>
      </div>
    </div>

    <!-- 底部内容 -->
    <common-footer></common-footer>
  </div>
</template>

<script type="text/ecmascript-6">
	import CommonHeader from './common/header';
  import CommonFooter from './common/footer';
  import newsApi from '@/api/news';

	export default {
    components: {
			CommonHeader, CommonFooter
		},
		data() {
			return {
        articleId: null,
        news: null
      };
		},
    mounted () {
      if(this.$route.query.id) {
        this.articleId = this.$route.query.id;
        this.getNews();
      } else{
        this.$route.back();
      }
    },
    methods: {
      // 获取收费类型列表
      async getNews() {
        this.news = await newsApi.getArticleInfo(this.articleId);
      }
    }
	};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .news-wrapper
    background: #ffffff;
    padding: 20px;
    border-radius: 3px;
    border-radius: 1px solid #eeeeee;
    margin-bottom: 20px;
    .title
      font-size: 16px
      color: #1B74AE
      line-height: 1.8
      text-overflow: ellipsis;
    .publish-time
      color: #A7A7A7
      font-size: 14px;
      line-height: 1.8
    .content
      padding-top: 10px;
      padding-bottom: 20px;
      color: #575757;
</style>
